import React, { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Context for Auth
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CausesPage from "./pages/CausesPage";
import DonatePage from "./pages/DonatePage";
import VolunteerPage from "./pages/VolunteerPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsConditions from "./pages/legal/TermsConditions";
import RefundPolicy from "./pages/legal/RefundPolicy";
import DonorDataPolicy from "./pages/legal/DonorDataPolicy";
import VolunteerTerms from "./pages/legal/VolunteerTerms";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

function AppContent() {
  const [admin, setAdmin] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const stored = localStorage.getItem('admin');
    if (stored) {
      setAdmin(JSON.parse(stored));
    }
  }, []);

  const login = (adminData) => {
    localStorage.setItem('admin', JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const logout = () => {
    localStorage.removeItem('admin');
    setAdmin(null);
  };

  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <AuthContext.Provider value={{ admin, login, logout, API }}>
      <div className="min-h-screen flex flex-col bg-cream">
        {!isAdminRoute && <Header />}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/causes" element={<CausesPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin/*" element={<AdminPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/donor-data-policy" element={<DonorDataPolicy />} />
            <Route path="/volunteer-terms" element={<VolunteerTerms />} />
          </Routes>
        </main>
        {!isAdminRoute && <Footer />}
        <Toaster position="top-right" richColors />
      </div>
    </AuthContext.Provider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
